import {
    CREATE_ACTIVITY_TEMPLATE_REQUEST,
    CREATE_ACTIVITY_TEMPLATE_SUCCESS,
    CREATE_ACTIVITY_TEMPLATE_FAIL,
    READ_ACTIVITY_TEMPLATE_BY_ID_REQUEST,
    READ_ACTIVITY_TEMPLATE_BY_ID_SUCCESS,
    READ_ACTIVITY_TEMPLATE_BY_ID_FAIL,
    UPDATE_ACTIVITY_TEMPLATE_REQUEST,
    UPDATE_ACTIVITY_TEMPLATE_SUCCESS,
    UPDATE_ACTIVITY_TEMPLATE_FAIL,
    DELETE_ACTIVITY_TEMPLATE_REQUEST,
    DELETE_ACTIVITY_TEMPLATE_SUCCESS,
    DELETE_ACTIVITY_TEMPLATE_FAIL,
    READ_ACTIVITY_TEMPLATE_REQUEST,
    READ_ACTIVITY_TEMPLATE_SUCCESS,
    READ_ACTIVITY_TEMPLATE_FAIL,
} from '../constant';

const initialState = {
    activityTemplates: [],
    activityTemplateDetail: null,
    loading: false,
    error: null,
    success: false,
    totalRecords: 0, // Total number of records
    currentPage: 1, // Current page
    totalPages: 0, // Total number of pages
};

export const activityTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ACTIVITY_TEMPLATE_REQUEST:
        case READ_ACTIVITY_TEMPLATE_BY_ID_REQUEST:
        case UPDATE_ACTIVITY_TEMPLATE_REQUEST:
        case DELETE_ACTIVITY_TEMPLATE_REQUEST:
        case READ_ACTIVITY_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case CREATE_ACTIVITY_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                activityTemplates: [...state.activityTemplates, action.payload],
            };

        case READ_ACTIVITY_TEMPLATE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                activityTemplateDetail: action.payload,
            };

        case UPDATE_ACTIVITY_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                activityTemplates: state.activityTemplates.map((template) =>
                    template.id === action.payload.id ? action.payload : template
                ),
            };

        case DELETE_ACTIVITY_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                activityTemplates: state.activityTemplates.filter(
                    (template) => template.id !== action.payload
                ),
            };

        case READ_ACTIVITY_TEMPLATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case READ_ACTIVITY_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                activityTemplates: action.payload.data,
                totalRecords: action.payload?.total_count,
               
            };
        case READ_ACTIVITY_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case CREATE_ACTIVITY_TEMPLATE_FAIL:
        case READ_ACTIVITY_TEMPLATE_BY_ID_FAIL:
        case UPDATE_ACTIVITY_TEMPLATE_FAIL:
        case DELETE_ACTIVITY_TEMPLATE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};
